import { render, staticRenderFns } from "./logistics_delivery.vue?vue&type=template&id=4d58238a&scoped=true"
import script from "./logistics_delivery.vue?vue&type=script&lang=js"
export * from "./logistics_delivery.vue?vue&type=script&lang=js"
import style0 from "./logistics_delivery.vue?vue&type=style&index=0&id=4d58238a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d58238a",
  null
  
)

export default component.exports